import { CRMRequestModal } from "./CRMRequestModal";
import { useState } from "react";
import { ReuseButton } from "../../../../ui";
import { Stack, Typography } from "@mui/material";
import { CheckInCircleIcon } from "../../../../images";
import { CRMMenu } from "./CRMMenu";
import { Integration } from "../../../../../types/enums";

type Props = {
  currentEmail: string;
  setCurrentEmail: (email: string, crmType: Integration) => void;
  isDisabled: boolean;
  crmType: Integration;
};
export const RequestCRMBtn = ({
  currentEmail,
  setCurrentEmail,
  isDisabled,
  crmType,
}: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const setCurrentEmailHandler = (email: string) => {
    setCurrentEmail(email, crmType);
    setIsOpen(false);
  };

  return (
    <Stack alignItems={"flex-start"}>
      {currentEmail ? (
        <Stack flexDirection={"row"} alignItems={"center"} gap={"8px"}>
          <Typography variant="button" sx={{ color: "#464646" }}>
            Email for Credential Request Added
          </Typography>
          <CheckInCircleIcon width={"16px"} height={"16px"} />
          <CRMMenu
            isDisabled={isDisabled}
            currentEmail={currentEmail}
            setCurrentEmail={setCurrentEmail}
            crmType={crmType}
          />
        </Stack>
      ) : (
        <ReuseButton onClick={() => setIsOpen(true)} disabled={isDisabled}>
          Credentials Request
        </ReuseButton>
      )}

      {isOpen && (
        <CRMRequestModal
          currentEmail={currentEmail}
          setCurrentEmail={setCurrentEmailHandler}
          onClose={() => setIsOpen(false)}
          isLoading={false}
          modalType={"add"}
          crmType={crmType}
        />
      )}
    </Stack>
  );
};
